/**
 * Typedef used for the button text. 
 */
export enum ListType {
    RESULTS = "Nominate",
    NOMINATIONS = "Remove"
}